import React, { useState } from 'react'
import { Box, Button, CircularProgress, TextField, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { CognitoAuthProviderType, useAuth } from '../../auth/AuthProvider'

export type LoginFormProps = {}


const LoginForm = (props: LoginFormProps) => {
    let navigate = useNavigate()

    let auth: CognitoAuthProviderType = useAuth()

    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [errorMessage, setErrorMessage] = useState<string | undefined>()

    const [loading, setLoading] = React.useState(false);

    const handleSubmit = async (event: any) => {
        event.preventDefault();
        setLoading(true)

        try {
            await auth.signin(username, password)
            setErrorMessage(undefined)
            navigate('/')
        } catch (error) {
            setErrorMessage('Please try again.')
            setLoading(false);
        }
    }


    return (

        <form id="login-form" onSubmit={handleSubmit}>
            {loading &&
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <CircularProgress />
                </Box>
            }
            <TextField
                fullWidth
                label="Username"
                onChange={(e) => { setUsername(e.target.value) }}
                value={username}
                variant="standard" />
            <TextField
                fullWidth
                label="Password"
                onChange={(e) => { setPassword(e.target.value) }}
                type={'password'}
                value={password}
                variant="standard" />
            <br />
            {errorMessage &&
                <Typography className="error" variant="body1">{errorMessage}</Typography>
            }
            <Button disabled={loading} variant="contained" type="submit">Sign In</Button>

        </form>

    )
}

export default LoginForm